import { createFileRoute, notFound } from "@tanstack/react-router"

import { PagePanel } from "@repo/ui/components/ui/page-panel"
import { ClientReportPage } from "~/modules/reports/components/client-report-page"
import { useFeatureConfigs } from "~/modules/system-config/hooks/use-feature-configs"

export const Route = createFileRoute("/_protected-layout/_os-layout/reports")({
  component: RouteComponent,
})

function RouteComponent() {
  const { isReportingOn } = useFeatureConfigs()

  if (!isReportingOn) {
    throw notFound()
  }

  return (
    <PagePanel title="Clients Report">
      <ClientReportPage />
    </PagePanel>
  )
}
